<div class="dashboard-container">
  <section class="hero-section">
    <div class="hero-content">
      <mat-icon class="hero-icon">dashboard</mat-icon>
      <h1>NRG Metrics Portal</h1>
      <p>Director data and statistical reports</p>
    </div>
  </section>

  <section class="quick-access-section">
    <div class="quick-access-grid">
      @for (card of cards(); track card.title) {
        <mat-card
          class="access-card"
          [class.disabled]="card.disabled"
          [attr.aria-disabled]="card.disabled || null"
          (click)="navigateTo(card)"
        >
          <mat-card-content>
            <div class="card-icon-wrapper" [style.background-color]="card.color">
              <mat-icon class="card-icon">{{ card.icon }}</mat-icon>
            </div>
            <h3 class="card-title">{{ card.title }}</h3>
            <p class="card-description">{{ card.description }}</p>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </section>

  <section class="welcome-section">
    <mat-icon class="welcome-icon">auto_stories</mat-icon>
    <div class="welcome-text">
      <h2>Welcome to the NRG Metrics Portal</h2>
      <p>
        Your gateway to one of the most comprehensive corporate-governance datasets available — built on years of
        carefully curated director profiles, ownership structures, and board-level insights. Browse the
        <strong>Directors Database</strong> to explore profiles, qualifications, and career histories, or head to
        <strong>Data for Statistics</strong> to filter the dataset along the dimensions that matter to you and
        export ready-to-analyse reports.
      </p>
    </div>
  </section>

  <section class="contact-bar">
    <a href="https://nrgmetrics.com/contact-us/" target="_blank" rel="noopener" class="contact-link">
      <mat-icon class="contact-icon">support_agent</mat-icon>
      Contact
    </a>
    <span class="contact-divider"></span>
    <a href="mailto:info@nrgmetrics.com" class="contact-link">
      <mat-icon class="contact-icon">email</mat-icon>
      info&#64;nrgmetrics.com
    </a>
  </section>
</div>
